"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.isDeepEqual = void 0;

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _iterableToArrayLimit(arr, i) { if (typeof Symbol === "undefined" || !(Symbol.iterator in Object(arr))) return; var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

var type = function type(source) {
  return Array.isArray(source) ? "Array" : source instanceof Date ? "Date" : source instanceof RegExp ? "RegExp" : source instanceof Object ? "Object" : "other";
};

var _isDeepEqual = function _isDeepEqual(a, b) {
  // added 100k ops/sec
  if (a === b) {
    return true;
  }

  var aType = type(a);
  var bType = type(b);

  if (aType !== bType) {
    return false;
  } //


  if (aType === "Array") {
    if (a.length !== b.length) {
      return false;
    }

    for (var i = 0, length = a.length; i < length; i++) {
      if (!_isDeepEqual(a[i], b[i])) {
        return false;
      }
    }

    return true;
  } //


  if (aType === "Object") {
    var aliceEntries = Object.entries(a);
    var bobEntries = Object.entries(b);

    if (aliceEntries.length !== bobEntries.length) {
      return false;
    }

    for (var _i = 0, _length = aliceEntries.length; _i < _length; _i++) {
      var _aliceEntries$_i = _slicedToArray(aliceEntries[_i], 2),
          aliceKey = _aliceEntries$_i[0],
          aliceValue = _aliceEntries$_i[1];

      if (!_isDeepEqual(b[aliceKey], aliceValue)) {
        return false;
      }
    }

    return true;
  } //


  if (aType === "RegExp") {
    return a.toString() === b.toString();
  } //


  if (aType === "Date") {
    return a.getTime() === b.getTime();
  }

  return false;
};
/**
 * Determine if two variables are structurally equal
 *
 * @param {Any} a Source input
 * @param {Any} b Other source input
 *
 * @returns {Boolean} True if inputs are structurally equal, false otherwise
 *
 * @name isDeepEqual
 * @tag Core
 * @signature (a: Any, b: Any): Boolean
 * @signature (a: Any)(b: Any): Boolean
 *
 * @see {@link clone}
 *
 * @example
 * deepEqual(
 *   {b: 3, a: 2},
 *   {a: 2, b: 3}
 * )
 * // => true
 *
 * deepEqual(
 *   {a :[1, 2]}
 * )(
 *   {a: [2, 1]}
 * )
 * // => false
 */


var isDeepEqual = function isDeepEqual() {
  for (var _len = arguments.length, params = new Array(_len), _key = 0; _key < _len; _key++) {
    params[_key] = arguments[_key];
  }

  if (params.length <= 1) {
    return function (b) {
      return _isDeepEqual(params[0], b);
    };
  }

  return _isDeepEqual.apply(void 0, params);
};

exports.isDeepEqual = isDeepEqual;